import { render, staticRenderFns } from "./CampaignPreview.vue?vue&type=template&id=097b2cbc&scoped=true"
import script from "./CampaignPreview.vue?vue&type=script&lang=js"
export * from "./CampaignPreview.vue?vue&type=script&lang=js"
import style0 from "./CampaignPreview.vue?vue&type=style&index=0&id=097b2cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b2cbc",
  null
  
)

export default component.exports